<app-resource-form-card
  [title]="service.title()"
  [resource]="service.resource"
  [detailed]="detailed()"
  [list]="true"
  [createButton]="access()?.servicio?.actions?.create">
  <p-table
    [value]="value()"
    [paginator]="true"
    [rows]="5"
    [rowsPerPageOptions]="[5, 10, 20]"
    [scrollable]="true"
    scrollHeight="flex">
    <ng-template pTemplate="header" let-columns>
      <tr>
        <th pSortableColumn="name" class="min-w-32">
          Nombre <p-sortIcon field="name" />
        </th>
        @if (detailed()) {
          <th pSortableColumn="description" class="min-w-32">
            Descripcion <p-sortIcon field="description" />
          </th>
          @if (access()?.contract?.actions?.read) {
            <th pSortableColumn="contract.name">
              Contrato <p-sortIcon field="contract.name" />
            </th>
          }
        }
        <th class="action">
          Acciones
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-value>
      <tr>
        <td>{{ value.name }}</td>
        @if (detailed()) {
          <td>{{ value.formattedDescription }}</td>
          @if (access()?.contract?.actions?.read) {
            <td>{{ value.contract.name }}</td>
          }
        }
        <td>
          <div>
            <app-resource-button-group
              [resource]="service.resource"
              [resourceId]="value._id"
              [detailsButton]="true"
              [editButton]="access()?.servicio?.actions?.update"
              [deleteButton]="access()?.servicio?.actions?.delete"
              [iconOnly]="true">
            </app-resource-button-group>
          </div>
        </td>
      </tr>
    </ng-template>
  </p-table>
</app-resource-form-card>

